import { FC, ReactElement } from "react";

const Equalizer:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M14 7h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v9h2v-9zM12 4h2v2h-2v-2zM9.25 13c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-9h-2v9h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v3h2v-3h0.25zM7 10h2v2h-2v-2zM4.25 7c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.413 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.337 0.75 0.75 0.75h0.25v9h2v-9h0.25zM2 4h2v2h-2v-2z"></path>
        </svg>
    )
}

export default Equalizer;